import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import NotificationElementStyle from '../assets/css/NotificationElement.module.css';
import dayjs from "dayjs";
import {useDesktop} from "../provider/DesktopContext";
import {useAppContext} from "../provider/appProvider";
import api from "../services/api";

const CATEGORY_LABELS = {
  alertes: 'Alertes',
  information: 'Information',
  equipements: 'Équipements',
};

// Une icône par catégorie, comme dans l'app : triangle d'alerte, caméra, éclair, et la
// cloche en repli. Les icônes du CDN sont indexées par `type`, pas par catégorie.
const CATEGORY_ICONS = {
  alertes: (
    <>
      <path d="M12 4 2.5 20.5h19L12 4Z"/>
      <path d="M12 10v4"/>
      <path d="M12 17.5h.01"/>
    </>
  ),
  equipements: (
    <>
      <rect x="3" y="6.5" width="12.5" height="11" rx="2"/>
      <path d="M15.5 11 21 7.5v9L15.5 13Z"/>
    </>
  ),
  information: (
    <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z"/>
  ),
  default: (
    <>
      <path d="M18 16v-5a6 6 0 1 0-12 0v5l-1.5 2h15L18 16Z"/>
      <path d="M10 20a2 2 0 0 0 4 0"/>
    </>
  ),
};

const CategoryIcon = ({ category, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {CATEGORY_ICONS[category] ?? CATEGORY_ICONS.default}
  </svg>
);

const NotificationElement = (props) => {
  const {
    id, title, description, callback, calledBy, readed, seen, createdAt, thumbnail,
    fullDate = false, category = null, highlight = false, onSee, onRead,
  } = props;

  const navigate = useNavigate();

  const {setNotifications} = useAppContext();

  const isDesktop = useDesktop();

  const patchNotification = (field) => {
    setNotifications((current) => current.map((notification) => {
      return notification.id === id ? { ...notification, [field]: new Date() } : notification;
    }));
  };

  useEffect(() => {
    if (!seen) {
      patchNotification('seen_at');
      if (onSee) {
        onSee(id);
      }
      api.patch(`/notifications/${id}/see`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallCallback = (event) => {
    if (!readed) {
      patchNotification('readed_at');
      if (onRead) {
        onRead(id);
      }
      api.patch(`/notifications/${id}/read`);
    }

    if (callback) {
      navigate(callback, { replace: true });
    }
  }

  return (
    <div className={`${NotificationElementStyle.element} ${highlight ? NotificationElementStyle.highlight : ''}`} onClick={handleCallCallback}>
      {isDesktop &&
        <div className={`${NotificationElementStyle.icon} ${category ? NotificationElementStyle[category] : ''}`}>
          <CategoryIcon category={category} size={22}/>
        </div>
      }
      <div className={NotificationElementStyle.content}>
        <div className={NotificationElementStyle.left}>
          {!isDesktop &&
            <div className={`${NotificationElementStyle.iconMobile} ${category ? NotificationElementStyle[category] : ''}`}>
              <CategoryIcon category={category} size={22}/>
            </div>
          }
          <div className={NotificationElementStyle.text}>
            {category &&
              <span className={`${NotificationElementStyle.badge} ${NotificationElementStyle[category] ?? ''}`}>
                {CATEGORY_LABELS[category] ?? category}
              </span>
            }
            <span className={NotificationElementStyle.title}>{title}</span>
            <span
              className={NotificationElementStyle.description}>{description}{(description && calledBy) && '・'}{calledBy}</span>
            <span
              className={NotificationElementStyle.description_02}>{dayjs(createdAt).format(fullDate ? '[Le] DD MMMM YYYY [à] HH[h]mm [et] ss[s]' : '[À] HH[h]mm [et] ss[s]')}</span>
          </div>
        </div>

        <div className={NotificationElementStyle.right}>
          {thumbnail == null &&
            <>
              {/*<LoaderIcon className={'loader'} height={40} width={40}></LoaderIcon>*/}
            </>
          }
          {thumbnail != null &&
            <>
              <img loading="lazy" className={NotificationElementStyle.thumbnail} src={thumbnail}
                   alt="Moment de la capture"
                   onError={(e) => { e.target.style.display = 'none'; }}/>
            </>
          }

        </div>
      </div>
      {!readed &&
        <div className={`${NotificationElementStyle.notReaded} ${category === 'alertes' ? NotificationElementStyle.notReadedAlert : ''}`}></div>
      }
    </div>
  );
};

export default NotificationElement;
